import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {environment} from 'src/environments/environment.prod';

@Component({
    selector: 'app-dialog-layout-inner-x',
    templateUrl: './dialog-layout-inner-x.component.html',
    styleUrls: ['./dialog-layout-inner-x.component.scss'],
    standalone: false
})
export class DialogLayoutInnerXComponent implements OnInit {
  @Input() title = '';
  @Input() description = '';
  @Input() btnText = '';
  @Input() pageIndicator = '';
  @Input() disableSubmit = false;

  @Input() minHeight = '300px';
  @Input() dialogWarning: string | null;
  @Input() closeIconPath: string;
  @Input() borderRadius: string;

  @Input() hideActions = false;
  @Input() overflowMode: 'default' | 'scroll' | 'inherit' | 'visible' = 'default';
  @Input() wideOnMobile = false;
  @Input() mobileInvoiceLayout = false;
  @Input() centerContent = false;

  @ContentChild('content') content!: TemplateRef<any>;
  @ContentChild('actions') actions!: TemplateRef<any>;
  @ViewChild('scrollableContent') scrollableContent!: ElementRef;

  /*  TODO: rename close */
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter();
  @Output() confirm = new EventEmitter();

  @HostBinding('class.overflow-scroll')
  get overflowScrollClass(): boolean {
    return this.overflowMode === 'scroll';
  }

  @HostBinding('class.overflow-inherit')
  get overflowInheritClass(): boolean {
    return this.overflowMode === 'inherit';
  }

  @HostBinding('class.overflow-visible')
  get overflowVisibleClass(): boolean {
    return this.overflowMode === 'visible';
  }

  @HostBinding('class.wide-on-mobile')
  get wideOnMobileClass(): boolean {
    return this.wideOnMobile;
  }

  @HostBinding('class.mobile-invoice-layout')
  get mobileInvoiceLayoutClass(): boolean {
    return this.mobileInvoiceLayout;
  }

  @HostBinding('class.center-content')
  get centerContentClass(): boolean {
    return this.centerContent;
  }

  deployUrl: string;

  constructor() {}

  ngOnInit(): void {
    this.deployUrl = environment.deploy_url;
  }

  closeDialog() {
    this.close.emit();
  }

  getImagePath() {
    if (this.closeIconPath) {
      return this.deployUrl + this.closeIconPath;
    } else {
      return this.deployUrl + 'assets/icons/cancel-icon.svg';
    }
  }

  handleConfirm() {
    this.confirm.emit();
  }

  scrollToTop() {
    this.scrollableContent.nativeElement.scrollTop = 0;
  }
}
